module.exports = "https://web-assets.ifttt.com/packs/media/layout/chevron-right-black-8b674b98.svg";